import React, { Component } from 'react';
import moment from 'moment';
import PropTypes from 'prop-types';
import { Popup } from 'semantic-ui-react';
import Calendar from '../../Calendar/Calendar';

class DeadlineCalendar extends Component {
  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
    this.close = this.close.bind(this);
    this.state = { date: null };
  }

  handleChange({ selectedElement: element, selectedDate }) {
    const { rushFeeDays, onChange } = this.props;
    const lastRushFeeDay = moment()
      .startOf('day')
      .add(rushFeeDays, 'day');

    this.setState(
      { date: selectedDate, trigger: null },
      () =>
        selectedDate.isSameOrBefore(lastRushFeeDay)
          ? this.openTooltip(element)
          : onChange(selectedDate),
    );
  }

  openTooltip(element) {
    this.setState({ trigger: element }, () => {
      const { date } = this.state;
      this.props.onChange(date);
    });
  }

  close() {
    this.setState({ trigger: null });
  }

  render() {
    return (
      <div>
        <Calendar
          onChange={this.handleChange}
          close={this.close}
          getDayStyle={this.props.getDayStyle}
          disablePast
        />
        <Popup
          open={!!this.state.trigger}
          context={this.state.trigger}
          position="top center"
        >
          {this.props.children}
        </Popup>
      </div>
    );
  }
}

DeadlineCalendar.propTypes = {
  children: PropTypes.object,
  onChange: PropTypes.func,
  getDayStyle: PropTypes.func.isRequired,
  rushFeeDays: PropTypes.number,
};

export default DeadlineCalendar;



// WEBPACK FOOTER //
// ./src/components/Deadline/DeadlineCalendar/DeadlineCalendar.js